import { api } from "@/api/client";
import type { NotificationDto, NotificationsListResponse } from "@/types/api/notifications";

export async function getNotifications(): Promise<NotificationsListResponse> {
  const { data } = await api.get<NotificationsListResponse>("/v1/notifications");
  return data;
}

export async function markNotificationRead(id: string): Promise<NotificationDto> {
  const { data } = await api.post<NotificationDto>(`/v1/notifications/${id}/read`);
  return data;
}

export async function markAllNotificationsRead(): Promise<{ updated: number }> {
  const { data } = await api.post<{ updated: number }>("/v1/notifications/read-all");
  return data;
}

export async function deleteNotification(id: string): Promise<void> {
  await api.delete(`/v1/notifications/${id}`);
}

export async function clearAllNotifications(): Promise<{ deleted: number }> {
  const { data } = await api.delete<{ deleted: number }>("/v1/notifications");
  return data;
}
